var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCssTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 138,
    viewBox: "0 0 218 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_342_166)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 160,
    height: 80,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 29.5,
    width: 159,
    height: 79,
    rx: 19.5,
    stroke: "#EAE3D2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.272 78.04C125.032 78.84 123.292 79.24 121.052 79.24C118.052 79.24 115.572 78.3 113.612 76.42C111.672 74.52 110.702 72.01 110.702 68.89C110.702 65.83 111.662 63.34 113.582 61.42C115.522 59.48 118.012 58.51 121.052 58.51C123.272 58.51 125.002 58.88 126.242 59.62V63.31C124.722 62.43 123.042 61.99 121.202 61.99C119.362 61.99 117.822 62.62 116.582 63.88C115.362 65.12 114.752 66.79 114.752 68.89C114.752 70.99 115.362 72.66 116.582 73.9C117.822 75.14 119.432 75.76 121.412 75.76C123.312 75.76 124.932 75.26 126.272 74.26V78.04ZM142.003 73.33C142.003 75.13 141.353 76.57 140.053 77.65C138.773 78.71 137.083 79.24 134.983 79.24C132.703 79.24 130.813 78.81 129.313 77.95V74.08C131.033 75.32 132.913 75.94 134.953 75.94C135.873 75.94 136.613 75.72 137.173 75.28C137.733 74.82 138.013 74.21 138.013 73.45C138.013 73.09 137.943 72.77 137.803 72.49C137.663 72.21 137.373 71.93 136.933 71.65C136.513 71.37 136.183 71.17 135.943 71.05C135.723 70.93 135.253 70.71 134.533 70.39C134.333 70.29 134.183 70.22 134.083 70.18C133.343 69.84 132.743 69.54 132.283 69.28C131.823 69 131.323 68.63 130.783 68.17C130.243 67.71 129.833 67.16 129.553 66.52C129.293 65.88 129.163 65.15 129.163 64.33C129.163 62.61 129.793 61.23 131.053 60.19C132.333 59.15 134.023 58.63 136.123 58.63C138.023 58.63 139.663 58.96 141.043 59.62V63.28C139.543 62.38 137.943 61.93 136.243 61.93C135.303 61.93 134.563 62.14 134.023 62.56C133.503 62.98 133.243 63.52 133.243 64.18C133.243 64.84 133.523 65.39 134.083 65.83C134.663 66.25 135.523 66.72 136.663 67.24C137.463 67.6 138.113 67.92 138.613 68.2C139.113 68.46 139.653 68.83 140.233 69.31C140.833 69.79 141.273 70.37 141.553 71.05C141.853 71.71 142.003 72.47 142.003 73.33ZM157.531 73.33C157.531 75.13 156.881 76.57 155.581 77.65C154.301 78.71 152.611 79.24 150.511 79.24C148.231 79.24 146.341 78.81 144.841 77.95V74.08C146.561 75.32 148.441 75.94 150.481 75.94C151.401 75.94 152.141 75.72 152.701 75.28C153.261 74.82 153.541 74.21 153.541 73.45C153.541 73.09 153.471 72.77 153.331 72.49C153.191 72.21 152.901 71.93 152.461 71.65C152.041 71.37 151.711 71.17 151.471 71.05C151.251 70.93 150.781 70.71 150.061 70.39C149.861 70.29 149.711 70.22 149.611 70.18C148.871 69.84 148.271 69.54 147.811 69.28C147.351 69 146.851 68.63 146.311 68.17C145.771 67.71 145.361 67.16 145.081 66.52C144.821 65.88 144.691 65.15 144.691 64.33C144.691 62.61 145.321 61.23 146.581 60.19C147.861 59.15 149.551 58.63 151.651 58.63C153.551 58.63 155.191 58.96 156.571 59.62V63.28C155.071 62.38 153.471 61.93 151.771 61.93C150.831 61.93 150.091 62.14 149.551 62.56C149.031 62.98 148.771 63.52 148.771 64.18C148.771 64.84 149.051 65.39 149.611 65.83C150.191 66.25 151.051 66.72 152.191 67.24C152.991 67.6 153.641 67.92 154.141 68.2C154.641 68.46 155.181 68.83 155.761 69.31C156.361 69.79 156.801 70.37 157.081 71.05C157.381 71.71 157.531 72.47 157.531 73.33Z",
    fill: "#333333",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.94 47L61.0829 85.4165L75.23 90.4831L89.3772 85.4165L92.5201 47H57.94ZM86.1354 54.7648L85.7031 59.3558L75.3201 64.1409L75.2931 64.1506H85.3339L84.1812 78.3796L75.3381 81.1653L66.441 78.3311L65.8646 71.1583H70.2682L70.5563 74.8758L75.2931 76.1667L80.2189 74.6719L80.5521 68.693L65.5765 68.6445V68.6348L65.5584 68.6445L65.2343 64.1506L75.3291 59.6179L75.9144 59.3558H64.847L64.3247 54.7648H86.1354Z",
    fill: "#208FE6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_342_166",
    x: 0,
    y: 0,
    width: 218,
    height: 138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_342_166"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_342_166"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_342_166",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssTag);
export default __webpack_public_path__ + "static/media/CSSTag.643b0551.svg";
export { ForwardRef as ReactComponent };